import { render, staticRenderFns } from "./SetWorker.vue?vue&type=template&id=41035456"
import script from "./SetWorker.vue?vue&type=script&lang=js"
export * from "./SetWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports